import * as React from "react"
import {Skeleton} from "@mui/material"

import {RepricingTable} from "../@components"
import {disabledRepricing, disabledEmail, isLoadingRepricingFormChecker, repricingFormCheckerData} from "../@signals";
import {isEmpty} from "@ui-seeker/utils";


export default function RepricingChecker() {
	if (isLoadingRepricingFormChecker.value) return <Skeleton height={500} variant="rectangular" />
	if (isEmpty(repricingFormCheckerData.value)) return <></>

    return <RepricingTable
		id="repricing-checker-table"
		title="Autoprice preview"
		data={repricingFormCheckerData.value.notification || []}
		numScope={repricingFormCheckerData.value.numProducts}
		updated={repricingFormCheckerData.value.update}
		same={repricingFormCheckerData.value.samePrice}
		increase={repricingFormCheckerData.value.increasePrice}
		decrease={repricingFormCheckerData.value.decreatePrice}
		columns={{
			applyRule: true,
			imageSku: true,
			sku: true,
			myPrice: true,
			newPrice: !disabledRepricing.value,
			diffPrice: !disabledRepricing.value,
			notification: !disabledEmail.value,
			retailer: true
		}}
	/>
}